import { MyProfileForm } from '@business/workflows/ComponentUI/MyProfileForm';
import { ProfileLayout } from 'src/layouts/ProfileLayout';

const MyProfile = () => {
  return (
    <ProfileLayout wrapperClassName="max-w-5xl">
      <div className="flex items-center justify-center">
        <MyProfileForm isEdit={false} />
      </div>
    </ProfileLayout>
  );
};

export default MyProfile;
